export const getInitialSubmitData = (src) => ({
  id: src?.id || null,
  avatar: src?.avatar || null,
  bio: src?.bio || "",
  specialities: src?.specialities || [],
  experience: src?.experience || [],
  education: src?.education || [],
  certifications: src?.certifications || [],
  memberships: src?.memberships || [],
  languages: src?.languages || [],
  instituteCertifications: src?.instituteCertifications || [],
  website: src?.website || "",
  linkedIn: src?.linkedIn || "",
  twitter: src?.twitter || "",
  fb: src?.fb || "",
  instagram: src?.instagram || "",
  address: src?.address || "",
  phone: src?.phone || "",
  desc: src?.desc || "",
  field1: src?.field1 || "",
  field2: src?.field2 || "",
  coverPicture: src?.coverPicture || "",
  hourlyRate: src?.hourlyRate || 0,
  hipaaCertificate: src?.hipaaCertificate || null,
  timeZone: src?.timeZone || "",
  backgroundCheck: src?.backgroundCheck || null,
  scopeOfPractice: src?.scopeOfPractice || null,
  insuranceCertificates: src?.insuranceCertificates || [],
  zoomLink: src?.zoomLink || "",
  businessAssociateAgreementFile: src?.businessAssociateAgreementFile || null,
  officeVerification: src?.officeVerification || [],
  hipaaAcknowledgement: src?.hipaaAcknowledgement || [],
  clientAgreementAckFile: src?.clientAgreementAckFile || null,
  leaseOrUtilityBill: src?.leaseOrUtilityBill || [],
  roomPrivacyPhotos: src?.roomPrivacyPhotos || [],
  emergencyPlanAck: src?.emergencyPlanAck || "",
  physicalOffice: src?.physicalOffice || "",
  postedHours: src?.postedHours || "",
  soundPrivacy: src?.soundPrivacy || "",
  licensed: src?.licensed || null,
  acceptInsurance: src?.acceptInsurance || null,
  agePreferences: src?.agePreferences
    ? Array.isArray(src.agePreferences)
      ? src.agePreferences.filter(Boolean)
      : String(src.agePreferences).split(",").map((s) => s.trim()).filter(Boolean)
    : [],
  gender: src?.gender || "",
  businessTaxReceipt: src?.businessTaxReceipt || "",
});
